let panelActionSeq = 0;
const groupActionTokens = new WeakMap();

function bumpGroupAction(groupEl) {
  panelActionSeq += 1;
  groupActionTokens.set(groupEl, panelActionSeq);
  return panelActionSeq;
}

function closest(el, selector) {
  if (!el) return null;
  if (el.closest) return el.closest(selector);
  // eslint-disable-next-line no-undef
  while (el) {
    if (el.matches && el.matches(selector)) return el;
    // eslint-disable-next-line no-param-reassign
    el = el.parentElement;
  }
  return null;
}

function dispatchPanelHidden(panelName) {
  window.dispatchEvent(
    new CustomEvent('phase2-action-panel-hidden', { detail: { panel: panelName } }),
  );
}

function dispatchPanelShown(panelName, targetPanel) {
  window.dispatchEvent(
    new CustomEvent('phase2-action-panel-shown', {
      detail: { panel: panelName, target: targetPanel },
    }),
  );
}

function dispatchPanelRefresh(panelName, targetPanel) {
  window.dispatchEvent(
    new CustomEvent('phase2-action-panel-refresh', {
      detail: { panel: panelName, target: targetPanel },
    }),
  );
}

function dispatchPanelOpenRequest(panelName, targetPanel, open) {
  window.dispatchEvent(
    new CustomEvent('phase2-action-panel-open-request', {
      detail: { panel: panelName, target: targetPanel, open },
    }),
  );
}

function hideAllInGroup(groupEl) {
  if (!groupEl) return;

  const panels = groupEl.querySelectorAll('.action-panel[data-panel]');
  panels.forEach((p) => {
    if (!p.classList.contains('is-visible')) return;
    const panelName = p.getAttribute('data-panel');
    dispatchPanelHidden(panelName);
    p.classList.remove('is-visible');
  });

  const toggles = groupEl.querySelectorAll('[data-toggle-panel].is-active');
  toggles.forEach((t) => t.classList.remove('is-active'));
}

function togglePanel(toggleEl) {
  const panelName = toggleEl && toggleEl.getAttribute('data-toggle-panel');
  if (!panelName) return;

  const groupEl = closest(toggleEl, '[data-panel-group]') || document;
  const targetPanel = groupEl.querySelector(`.action-panel[data-panel="${panelName}"]`);
  if (!targetPanel) return;

  const actionToken = bumpGroupAction(groupEl);
  const wasVisible = targetPanel.classList.contains('is-visible');
  const unreadAttr = toggleEl.getAttribute('data-panel-unread');
  const isManaged = unreadAttr !== null;
  const unreadCount = Number(unreadAttr) || 0;

  if (wasVisible && isManaged && unreadCount > 0) {
    dispatchPanelRefresh(panelName, targetPanel);
    return;
  }

  if (!wasVisible && isManaged) {
    dispatchPanelOpenRequest(panelName, targetPanel, () => {
      if (groupActionTokens.get(groupEl) !== actionToken) return false;
      if (!toggleEl.isConnected || !targetPanel.isConnected) return false;
      hideAllInGroup(groupEl);
      targetPanel.classList.add('is-visible');
      toggleEl.classList.add('is-active');
      dispatchPanelShown(panelName, targetPanel);
      return true;
    });
    return;
  }

  hideAllInGroup(groupEl);

  if (!wasVisible) {
    targetPanel.classList.add('is-visible');
    toggleEl.classList.add('is-active');
    dispatchPanelShown(panelName, targetPanel);
  }
}

function closePanel(closeEl) {
  const panelEl = closest(closeEl, '.action-panel');
  if (!panelEl) return;

  const groupEl = closest(panelEl, '[data-panel-group]') || document;
  bumpGroupAction(groupEl);
  const panelName = panelEl.getAttribute('data-panel');
  if (panelEl.classList.contains('is-visible')) {
    dispatchPanelHidden(panelName);
  }
  panelEl.classList.remove('is-visible');

  if (panelName && groupEl) {
    const toggles = groupEl.querySelectorAll(`[data-toggle-panel="${panelName}"]`);
    toggles.forEach((t) => t.classList.remove('is-active'));
  }
}

export default function initActionPanels() {
  // eslint-disable-next-line no-underscore-dangle
  if (window.__phase2ActionPanelsInit) return;
  // eslint-disable-next-line no-underscore-dangle
  window.__phase2ActionPanelsInit = true;

  document.addEventListener(
    'click',
    (e) => {
      const closeEl = closest(e.target, '[data-close-panel]');
      if (closeEl) {
        e.preventDefault();
        e.stopPropagation();
        closePanel(closeEl);
        return;
      }

      const toggleEl = closest(e.target, '[data-toggle-panel]');
      if (!toggleEl) return;
      e.preventDefault();
      e.stopPropagation();
      togglePanel(toggleEl);
    },
    true,
  );
}
